import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { getEmailValidationSchema } from '../../../../../../../utils/validation';
import { BusinessRuleBase } from '../../business/BusinessBase';
import { GenericValidation } from '../../../../../../../validations/GenericValidation';

const {
  formField: { principalEmailAddress },
} = loanFormModel;

export class PrincipalEmailValidation implements ValidationSchema {
  public name = principalEmailAddress.name;
  public label = principalEmailAddress.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalEmailAddress.requiredErrorMsg,
    value: principalEmailAddress.required,
  };
  public nullable = true;

  public when(schema: any, context: any) {
    const bl = new BusinessRuleBase(context.parent);
    if (bl.isPrincipal() && !bl.isTrust()) {
      return getEmailValidationSchema(principalEmailAddress);
    }

    return GenericValidation.create({
      nullable: true,
      required: false,
    });
  }
}

export default new Validation(new PrincipalEmailValidation());
